<rid-mechanic-background />

<rid-mechanic-wrapper>
  <rid-top-bar class="block w-full" name="Woordbouwen" [steps]="this.assignments().length" [progress]="progress()" />

  <rid-mechanic-content>
    <!-- title -->
    <rid-mechanic-title [title]="'Maak zo veel mogelijk woorden'" />

    <!-- assignment -->
    @for (assignment of [assignment()]; track assignment.id) {
      <div class="absolute flex h-full flex-col" animate.leave="anim-fade-out">
        <div class="grid grow place-items-center">
          <div class="absolute grid place-items-center gap-8" animate.leave="anim-fade-out">
            <!-- options -->
            <div class="flex gap-2">
              @for (option of assignment.options; track $index) {
                <div class="grid">
                  <rid-spacer class="stack-cell">
                    <rid-klank-card
                      [klank]="option"
                      animate.enter="anim-pop-in"
                      [style.animation-delay.ms]="500 + $index * 50"
                      ridSfx="BUBBLE_POP"
                      (animationend)="$last && $event.animationName === 'pop-in' ? revealAnswers() : undefined"
                    />
                  </rid-spacer>

                  @if (!canGoToNext()) {
                    <rid-draggable class="stack-cell" (moved)="onDragMove($event[0], $event[1])" (released)="onDragRelease($event, $index)">
                      <rid-klank-card
                        [klank]="option"
                        animate.enter="anim-pop-in"
                        [style.animation-delay.ms]="500 + $index * 50"
                        ridSfx="BUBBLE_POP"
                      />
                    </rid-draggable>
                  }
                </div>
              }
            </div>

            <!-- input -->
            <div
              class="relative"
              [class.invisible]="revealStage() !== 'INPUT'"
              [class.pointer-events-none]="revealStage() !== 'INPUT'"
              [class.anim-pop-in]="revealStage() === 'INPUT'"
              ridSfx="BUBBLE_POP"
            >
              <div class="flex items-center justify-center gap-2">
                <!-- prefix slot -->
                <rid-word-building-slot
                  #prefixDropZone
                  [longestOption]="longestOption()"
                  [value]="prefix()"
                  (cleared)="clearSlot('PREFIX')"
                />

                <!-- root -->
                <rid-word-building-kern [root]="assignment.root" [kern]="changedKern()" [phase]="kernPhase()" />

                <!-- suffix slot -->
                <rid-word-building-slot
                  #suffixDropZone
                  [longestOption]="longestOption()"
                  [value]="suffix()"
                  (cleared)="clearSlot('SUFFIX')"
                />
              </div>
              <rid-button
                class="absolute top-1/2 left-full ml-2 -translate-y-1/2"
                keybind="Enter"
                [disabled]="isChecking() || !hasInput() || seenWords().includes(currentWord())"
                (click)="check()"
              >
                <i-enter class="size-[1lh]" />
              </rid-button>
            </div>
          </div>
        </div>

        <!-- answers -->
        <div
          class="relative flex w-2xl flex-wrap justify-center gap-4 rounded-4xl bg-linear-to-b from-black/35 to-black/0 p-8 pb-24 xl:w-6xl"
          [class.invisible]="revealStage() === 'OPTIONS'"
          [class.pointer-events-none]="revealStage() === 'OPTIONS'"
          [class.anim-slide-from-bottom]="revealStage() !== 'OPTIONS'"
          ridSfx="SHORT_SLIDE"
          [ridSfxAnimations]="['slide-from-bottom']"
          (animationend)="revealStage() === 'ANSWERS' && $event.animationName === 'slide-from-bottom' ? revealInput() : undefined"
        >
          @for (answer of assignment.answers; track $index) {
            <rid-lettermix-word [word]="answer.display" [appearance]="answer.appearance" />
          }

          @if (canRevealAnswers()) {
            <rid-button
              class="absolute right-4 bottom-4"
              content="Laat antwoorden zien"
              appearance="NEUTRAL"
              variant="SECONDARY"
              size="SMALL"
              [disabled]="canGoToNext()"
              animate.enter="anim-pop-in"
              (click)="reveal()"
            />
          }
        </div>
      </div>
    }

    <!-- button -->
    @if (canGoToNext()) {
      <rid-bottom-button content="Volgende" animate.enter="wait-500" (clicked)="next()" />
    }

    <!-- feedback overlay -->
    <rid-overlay-feedback #overlayFeedback />
  </rid-mechanic-content>
</rid-mechanic-wrapper>
